import React from "react";
import s from './ThisDayInfo.module.scss'
import cloud from '../../../../assets/images/cloud.png'
import {ThisDayItem} from "./ThisDayItem";


export interface Item {
    icon_id: string,
    name: string,
    value: any
}

export const ThisDayInfo = ({data}: any) => {

    const items = [
        {
            icon_id: 'temp',
            name: 'Temperature -',
            value: Math.round(data.main.temp)+`°`,
        },
        {
            icon_id: 'pressure',
            name: 'Pressure -',
            value: data.main.pressure+ ` hPa`,
        },
        {
            icon_id: 'precipitation',
            name: 'Humidity -',
            value: data.main.humidity+ `%`,
        },
        {
            icon_id: 'wind',
            name: 'Wind -',
            value: data.wind.speed+ ` m/s`,
        },
    ];

    return (
        <div className={s.this__day_info}>
            <div className={s.this__day_info_items}>
                {items.map((item: Item) => (
                        <ThisDayItem key={item.icon_id} item={item} />
                    ))}
            </div>
            <img className={s.cloud__img} src={cloud} alt='cloud'/>
        </div>
    )
}